import {
    Color, Input, Kind, ModalWindow
} from '@usitsdasdesign/dds-react';
import { yupValidator } from 'lib/yup-validator';
import Dialog from 'molecules/Dialog';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

function SaveFilterModal({
    show, onClose, onSave, defaultFilterName = '', error
}) {
    const {
        watch, setValue, handleSubmit, formState: { errors }
    } = useForm({
        resolver: yupValidator(
            yup.object().shape({
                filterName: yup.string().required('Name is required')
            }),
        )
    });
   
    useEffect(() => {
        if (show) {
            setValue('filterName', defaultFilterName);
        }
    }, [show]);

    return (
        <Dialog
            title={defaultFilterName ? `Update Filter - ${defaultFilterName}` : 'Add filter'}
            show={show}
            size='md'
            actions={[
                {
                    label: 'Close',
                    kind: Kind.secondaryLoud,
                    color: Color.green,
                    isDisabled: false,
                    onClick: () => {
                        onClose();
                        delete errors.filterName;
                    }
                },
                {
                    label: defaultFilterName ? 'Update' : 'Add',
                    kind: Kind.primaryLoud,
                    color: Color.green,
                    isDisabled: false,
                    onClick: handleSubmit(onSave)
                }
            ]}
            onClose={() => {
                onClose();
                delete errors.filterName;
            }}
        >
            <div className="ModalContent__content">
                <Input
                    value={watch('filterName')}
                    valueChanged={(val) => setValue('filterName', val)}
                    isError={('filterName' in errors) || error}
                    errorMessage={errors.filterName?.message || error === 'Validation Error' && 'Please select an option to continue.'} 
                    size='l'
                    label='Name'
                    isRequired
                    placeholder='Enter name for the filter'
                />
            </div>
        </Dialog>
    );
}

export default SaveFilterModal;
